import React from 'react';
import LoffaTemplateModalBase from './LoffaTemplateModalBase';
import styles from "./LoffaTemplateModal.module.css"

const GATEWAY_BASE_URL = process.env.REACT_APP_API_GATEWAY_BASE;

const CreateLoffaTemplateModal = ({ isOpen, onClose, products, authToken }) => {
  const handleSave = async ({ selectedProduct, templateName, columns }) => {
    try {
      const payload = {
        productType: selectedProduct.id,
        name: templateName,
        dataTemplateColumns: columns.map(col => ({
          name: col.name,
          type: col.type,
          required: col.required,
          index: col.index,
          ...(col.type !== 'DateTime' && col.type !== 'Boolean' && {
            minLength: col.minLength ? parseInt(col.minLength, 10) : 0,
            maxLength: col.maxLength ? parseInt(col.maxLength, 10) : 1000,
          }),
        })),
      };

      const res = await fetch(`${GATEWAY_BASE_URL}/datamanager/api/Template`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error(`Failed to create template: ${res.status}`);
    } catch (err) {
      console.error(err);
      return 'Failed to save template';
    }
  };

  return (
    <LoffaTemplateModalBase
      isOpen={isOpen}
      onClose={onClose}
      products={products}
      authToken={authToken}
      title="Create Loffa Template"
      onSave={handleSave}
    />
  );
};

export default CreateLoffaTemplateModal;